import slice from './integrationSlice';

export * from './integrationSlice';

export default slice;
